import { WrenchTheme } from '@wds/styles';
import { merge } from 'lodash';

const changes = {
	palette: {
		name: 'HotCold',
		primary: {
			main: '#3787B0',
			contrast: '#ffffff',
			pressed: '#3787B0',
			hover: '#51a0c9',
		},
		border: { main: '#6D6D6D' },
		muted: {
			main: '#A0A8AD',
			contrast: '#3787B0',
		},
	},
};

export const HotColdTheme = merge({}, WrenchTheme, changes);
